/**
 * Location Picker — Multi-country, multi-governorate
 * Portal pattern: modal moves to <body> to escape header stacking context
 */
(function(){
  var R = window.__CART_REGIONS;
  if (!R) return;

  var LANG = document.documentElement.lang === 'ar' ? 'ar' : 'en';
  var saved = {
    country: (function(){var c=localStorage.getItem('jc_country')||'';return c==='jo'?'':c;})(),
    gov: localStorage.getItem('jc_gov') || ''
  };

  function renderGovs(container, cc) {
    var c = R.getCountry(cc);
    if (!c) return;
    var html = '<div class="loc-gov-grid">';
    Object.keys(c.governorates).forEach(function(code){
      var g = c.governorates[code];
      var active = (saved.country === cc && saved.gov === code) ? ' loc-gov--active' : '';
      html += '<button type="button" class="loc-gov' + active + '" data-gov="' + code + '" data-country="' + cc + '">' +
        '<span class="loc-gov-name">' + g['name_' + LANG] + '</span>' +
        '<span class="loc-gov-meta">' + g.days_min + '-' + g.days_max + ' ' + (LANG==='ar'?'أيام':'days') +
        ' · ' + (g.fee > 0 ? (c.currency==='IQD' ? g.fee.toLocaleString()+' '+(LANG==='ar'?'د.ع':'IQD') : g.fee+' '+(LANG==='ar'?'د.أ':'JOD')) : (LANG==='ar'?'مجاني':'Free')) +
        '</span></button>';
    });
    html += '</div>';
    container.innerHTML = html;
  }

  function updateAll() {
    var g = R.getGov(saved.country, saved.gov);
    var c = R.getCountry(saved.country);
    if (!g || !c) return;

    var name = c.flag + ' ' + g['name_' + LANG];
    document.querySelectorAll('[data-loc-display]').forEach(function(el){ el.textContent = name; });

    var eta = g.same_day
      ? (LANG==='ar' ? '⚡ توصيل نفس اليوم' : '⚡ Same-day delivery')
      : '🚚 ' + g.days_min + '-' + g.days_max + ' ' + (LANG==='ar' ? 'أيام عمل' : 'business days');
    document.querySelectorAll('[data-loc-eta]').forEach(function(el){ el.textContent = eta; });

    var fee = g.fee > 0
      ? (c.currency==='IQD' ? g.fee.toLocaleString()+' '+(LANG==='ar'?'د.ع':'IQD') : g.fee+' '+(LANG==='ar'?'د.أ':'JOD'))
      : (LANG==='ar' ? 'مجاني' : 'Free');
    document.querySelectorAll('[data-loc-fee]').forEach(function(el){ el.textContent = fee; });

    /* BUGFIX: the PDP "pb-delivery" block (governorate name + delivery ETA)
       reads from a completely different attribute set ([data-detected-governorate],
       .pb-delivery-value / [data-delivery-value]) that this picker never wrote to,
       so changing the governorate here never updated it. Bridge it directly here
       using the same governorate data already resolved above. */
    document.querySelectorAll('[data-detected-governorate]').forEach(function(el){ el.textContent = g['name_' + LANG]; });
    document.querySelectorAll('.pb-delivery-value, [data-delivery-value]').forEach(function(el){ el.textContent = eta; });

    window.dispatchEvent(new CustomEvent('location:changed', {
      detail: { country: saved.country, gov: saved.gov, data: g, countryData: c }
    }));
  }

  /* ─── Create a SINGLE shared modal appended to <body> ─── */
  var modal = document.querySelector('[data-loc-modal]');
  if (modal) {
    // Move the FIRST modal found to <body> (portal)
    document.body.appendChild(modal);
    modal.setAttribute('data-loc-portal', 'true');

    // Remove duplicate modals from other pickers (PDP, cart)
    document.querySelectorAll('[data-loc-modal]:not([data-loc-portal])').forEach(function(m){
      m.remove();
    });

    var govsEl = modal.querySelector('[data-loc-govs]');
    var tabs = modal.querySelectorAll('[data-country]');
    var closeBtns = modal.querySelectorAll('[data-loc-close]');

    function openModal() {
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      renderGovs(govsEl, saved.country || 'iq');
      tabs.forEach(function(t){ t.classList.toggle('loc-tab--active', t.dataset.country === (saved.country || 'iq')); });
    }
    function closeModal() {
      modal.hidden = true;
      document.body.style.overflow = '';
    }

    // Close buttons
    closeBtns.forEach(function(b){ b.addEventListener('click', closeModal); });

    // Country tabs
    tabs.forEach(function(tab){
      tab.addEventListener('click', function(e){
        e.stopPropagation();
        saved.country = tab.dataset.country;
        saved.gov = '';
        localStorage.setItem('jc_country', saved.country);
        localStorage.removeItem('jc_gov');
        tabs.forEach(function(t){ t.classList.toggle('loc-tab--active', t.dataset.country === saved.country); });
        renderGovs(govsEl, saved.country);
      });
    });

    // Gov selection
    govsEl.addEventListener('click', function(e){
      var btn = e.target.closest('[data-gov]');
      if (!btn) return;
      saved.country = btn.dataset.country;
      saved.gov = btn.dataset.gov;
      localStorage.setItem('jc_country', saved.country);
      localStorage.setItem('jc_gov', saved.gov);
      closeModal();
      updateAll();
    });

    // Wire ALL triggers (header, PDP, cart) to open this single modal
    document.querySelectorAll('[data-loc-trigger]').forEach(function(t){
      t.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        openModal();
      });
    });
  }

  /* Auto-detect: if no gov saved, guess from timezone */
  if (!saved.gov) {
    try {
      var tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
      if (tz.indexOf('Baghdad') >= 0 || tz.indexOf('Erbil') >= 0) {
        saved.country = 'iq';
        saved.gov = 'baghdad';
      } else {
        saved.country = 'iq';
        saved.gov = 'baghdad';
      }
      localStorage.setItem('jc_country', saved.country);
      localStorage.setItem('jc_gov', saved.gov);
    } catch(e) {
      saved.country = 'iq';
      saved.gov = 'baghdad';
    }
  }
  updateAll();
})();
